import { render, staticRenderFns } from "./DHL_F7.vue?vue&type=template&id=587e5516&scoped=true"
import script from "./DHL_F7.vue?vue&type=script&lang=js"
export * from "./DHL_F7.vue?vue&type=script&lang=js"
import style0 from "./DHL_F7.vue?vue&type=style&index=0&id=587e5516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587e5516",
  null
  
)

export default component.exports